export default "__VITE_ASSET__CLe55oV5__"